<template>
<div id="page-carga_ds" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Bitácora ZIP Datastage" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="bitacora.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="green" @click.native="downloadFile(props.row, 'xlsx')" title="Descarga Excel" v-tippy>
                                            <v-icon>get_app</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="downloadFile(props.row, 'zip')" title="Descarga ZIP" v-tippy>
                                            <v-icon>attachment</v-icon>
                                        </v-btn>

                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import {
    filter
} from 'minimatch';

export default {
    data() {
        return {
            fab: false,
            name: "datagrid",
            columns: [
                "RFCoPatenteAduanal",
                "Folio",
                "Fecha_Inicial",
                "Fecha_Final",
                "actions"
            ],
            show_loading: true,
            options: {
                filterable: ["RFCoPatenteAduanal",
                    "Folio",
                    "Fecha_Inicial",
                    "Fecha_Final"
                ],
                sortable: ["RFCoPatenteAduanal",
                    "Folio",
                    "Fecha_Inicial",
                    "Fecha_Final"
                ],

                headings: {
                    RFCoPatenteAduanal: "RFC o TAX ID",
                    Folio: "Folio",
                    Fecha_Inicial: "Fecha Inicial",
                    Fecha_Final: "Fecha Final",
                    actions: "Operaciones"
                }
            },
            show_loading: true,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Datastage",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Bitácora ZIP Datastage",
                    disabled: true,
                    href: ""
                }
            ],
            search: "",
            bitacora: {
                items: []
            },
        };
    },

    methods: {

        getBitacora: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc = this.$local_storage.get("rfc_grupo"); //Produccion
            axios.post(this.$hostname + "datastage/consultar_bitacora/", {
                    'rfc': rfc
                })
                .then(response => {
                    this.bitacora.items = response.data;
                    var filtered = this.bitacora.items.filter(function (el) {
                        return el.RFCoPatenteAduanal != null;
                    });
                    this.bitacora.items = filtered;

                    for (var k in this.bitacora.items) {
                        this.bitacora.items[k].Fecha_Inicial = moment(String(this.bitacora.items[k].Fecha_Inicial)).format("YYYY-MM-DD");
                        this.bitacora.items[k].Fecha_Final = moment(String(this.bitacora.items[k].Fecha_Final)).format("YYYY-MM-DD");
                    }
                    this.bitacora.items.sort(function (a, b) {
                        //Ordenar por fecha más reciente
                        return new Date(b.Fecha_Inicial) - new Date(a.Fecha_Inicial) ;
                    });

                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                   
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadFile: function (row, ext) {
            var rfc = this.$local_storage.get("rfc_grupo"); //Produccion            
            rfc = rfc.toString().trim().toUpperCase();
            let nombre = rfc + "/glosas/" + rfc + "-" + row.Folio + "_" + row.Fecha_Inicial + "_" + row.Fecha_Final + "." + ext;
            //alert(nombre);
            var datos = {
                id: nombre,
                bucket: "production.econnect.ds"
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },

    },
    created: function () {
        this.getBitacora();
        
   
    },
};
</script>
